module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_2.73eefed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_2.png
// module id = Lb9e
// module chunks = 19